import React from "react";
import { Outlet } from "react-router-dom";

const LayoutAuth = () => {
	return (
		<div className=" w-full h-screen flex justify-center items-center bg-1B1464 ">
			<Outlet />
		</div>
	);
};

export default LayoutAuth;
